import { Vue,Component,Watch } from 'vue-property-decorator';
import List from '@/assets/common/List/List.vue'
import { toCamel } from 'snake-camel';
import {notificationStatusByNotificationId} from "@/types/Component";
import moment from "moment";



type NotificationList = {
    id: string;
    title: string;
    content: string;
    publishDate: string;
    saveDate:string;
    isImportant: boolean;
    isDraft: boolean;
    selectedNotificationId : string;
};

type NotificationsGet = {
    notifications: NotificationList[];
}

export type Item = {
    id: string;
    publishDate: string;
    title: string;
    isImportant: boolean;
    isActive: boolean;
}

@Component({
    components: {
        List
    }
})
export default class NotificationStatusByNotification extends Vue {
    private list: any | null = null
    private items: Item[] | undefined = []
    private searchText = ''
    private clientBaseUrl = '/notification-status-by-notification'
    private baseUrl = '/notifications_status'
    private activeList: 'DATE' | 'IMPORTANT' = 'DATE'
    private notifications: NotificationList[] = []
    private notificationStatusByNotificationId =[] as notificationStatusByNotificationId [];
    private isLoading = false
    private headerTitle!: string
    private selectedNotification!: NotificationList
    private notificationTitle = ""
    private selectedNotificationId : string | null = null
    private isNotificationContent = false
    private isImportant = false
    private sortByCompanyNameASC = false
    private sortByUserNameASC = false
    private sortByReadAdminASC = false
    private sortByReadUserASC = false
    private sortByReadTotalASC = false
    private sortByUnReadAdminASC = false
    private sortByUnReadUserASC = false
    private sortByUnReadTotalASC = false
    private sumReadAdmin = 0;
    private sumReadUser = 0;
    private sumReadTotal = 0;
    private sumUnReadAdmin = 0;
    private sumUnReadUser = 0;
    private sumUnReadTotal = 0;

    private created() {
        this.getNotifications()
    }

    private getNotifications() {
        this.list = null
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}`).then(res => {
            this.notifications = (toCamel(res) as NotificationsGet).notifications as NotificationList[]
            this.setNotificationStatus(this.notifications?.[0].id,this.notifications?.[0].title,this.notifications?.[0].isImportant);
        })
        .finally(() => {
            this.list = this.notifications
            this.items = this.list
        })
    }

    @Watch('searchText')
    private doSearch() {
        this.init();
    }

    private init(){
        const filteredByKeyword = this.searchText ? this.list?.filter((item: Item) => item.title.indexOf(this.searchText) > -1): this.list;
        const sortArray: Item[] = filteredByKeyword
        if(this.activeList === 'IMPORTANT') {
            this.items = sortArray.sort((a, b) => (a.isImportant === b.isImportant ? 0 : a.isImportant ? -1 : 1));
        }else if(this.activeList === 'DATE'){
            this.items = sortArray.sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());
        }
    }

    private setNotificationStatus(id:string,title:string,isImportant:boolean){
        this.$router.push(`${this.clientBaseUrl}/${id}`, () => {return})
        this.$apiClient.doRequest("get", `${this.baseUrl}/${id}`).then((res) => {
        this.notificationStatusByNotificationId = res.notificationStatus
        this.sumReadAdmin = 0;
        this.sumReadUser = 0;
        this.sumReadTotal = 0;
        this.sumUnReadAdmin = 0;
        this.sumUnReadUser = 0;
        this.sumUnReadTotal = 0;
        // Calculate the sum  values
        for (const user of res.notificationStatus) {
        this.sumReadAdmin += parseInt(user.readAdmin);
        this.sumReadUser += parseInt(user.readUser);
        this.sumReadTotal += parseInt(user.readTotal);
        this.sumUnReadAdmin += parseInt(user.unreadAdmin);
        this.sumUnReadUser += parseInt(user.unreadUser);
        this.sumUnReadTotal += parseInt(user.unreadTotal);
        }
        this.notificationTitle = title
        this.isImportant = isImportant
        this.isAction(id);
        });
    }

    private isAction(id:string){
    setTimeout(() => {
        const newItems: Item[] = []
        this.items?.forEach((val) => {
            if(id === val.id){
                val.isActive = true
            }else {
                val.isActive = false
            }
            newItems.push(val)
        })
        this.items = newItems
    }, 100);
    }

    openSideBar = () => {
        if(document.body.classList.contains('sideopen')){
            document.body.classList.remove('sideopen')
        }else{
            document.body.classList.add('sideopen')
        }
    }

    private changeDateFormat(inputDate: string): string {
       // Create a new Date object from the input string (assumes input is in UTC)
        const utcDate = new Date(inputDate);

        const newDateFormat= moment(utcDate).format('YYYY/MM/DD HH:mm:ss')
        return newDateFormat;

        return newDateFormat;
    }

    //法人名のソート
    private sortByCompanyName(isSwitchAsc?: boolean) {
    this.sortByCompanyNameASC = isSwitchAsc ? !this.sortByCompanyNameASC : this.sortByCompanyNameASC
    this.notificationStatusByNotificationId.sort((a :any, b:any) => {
        const valueA = a.companyName || "";
        const valueB = b.companyName || "";
        if (valueA === "" || valueA === null) {
            return this.sortByCompanyNameASC ? 1 : -1;
          }
          if (valueB === "" || valueB === null) {
            return this.sortByCompanyNameASC ? -1 : 1;
          }
        return this.sortByCompanyNameASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
    })
  }

  //ユーザー名のソート
  private sortByUserName(isSwitchAsc?: boolean) {
    this.sortByUserNameASC = isSwitchAsc ? !this.sortByUserNameASC : this.sortByUserNameASC
    this.notificationStatusByNotificationId.sort((a :any, b:any) => {
        const valueA = a.userName;
        const valueB = b.userName;
        return this.sortByUserNameASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
    })
  }

  //既読管理者のソート
  private sortByReadAdmin(isSwitchAsc?: boolean) {
    this.sortByReadAdminASC = isSwitchAsc ? !this.sortByReadAdminASC : this.sortByReadAdminASC;
    this.notificationStatusByNotificationId.sort((a: any, b: any) => {
    const countA = a.readAdmin || 0;
    const countB = b.readAdmin || 0; 

    return this.sortByReadAdminASC ? countA - countB : countB - countA;
    });
  }

  //既読スタッフのソート
  private sortByReadUser(isSwitchAsc?: boolean) {
    this.sortByReadUserASC = isSwitchAsc ? !this.sortByReadUserASC : this.sortByReadUserASC;
    this.notificationStatusByNotificationId.sort((a: any, b: any) => {
    const countA = a.readUser || 0;
    const countB = b.readUser || 0; 

    return this.sortByReadUserASC ? countA - countB : countB - countA;
    });
  }
  //既読合計のソート
  private sortByReadTotal(isSwitchAsc?: boolean) {
    this.sortByReadTotalASC = isSwitchAsc ? !this.sortByReadTotalASC : this.sortByReadTotalASC;
    this.notificationStatusByNotificationId.sort((a: any, b: any) => {
    const countA = a.readTotal || 0;
    const countB = b.readTotal || 0; 

    return this.sortByReadTotalASC ? countA - countB : countB - countA;
    });
  }

  //未読管理者のソート
  private sortByUnReadAdmin(isSwitchAsc?: boolean) {
    this.sortByUnReadAdminASC = isSwitchAsc ? !this.sortByUnReadAdminASC : this.sortByUnReadAdminASC;
    this.notificationStatusByNotificationId.sort((a: any, b: any) => {
    const countA = a.unreadAdmin || 0;
    const countB = b.unreadAdmin || 0; 

    return this.sortByUnReadAdminASC ? countA - countB : countB - countA;
    });
  }

  //未読スタッフのソート
  private sortByUnReadUser(isSwitchAsc?: boolean) {
    this.sortByUnReadUserASC = isSwitchAsc ? !this.sortByUnReadUserASC : this.sortByUnReadUserASC;
    this.notificationStatusByNotificationId.sort((a: any, b: any) => {
    const countA = a.unreadUser || 0;
    const countB = b.unreadUser || 0; 

    return this.sortByUnReadUserASC ? countA - countB : countB - countA;
    });
  }

  //未読合計のソート
  private sortByUnReadTotal(isSwitchAsc?: boolean) {
    this.sortByUnReadTotalASC = isSwitchAsc ? !this.sortByUnReadTotalASC : this.sortByUnReadTotalASC;
    this.notificationStatusByNotificationId.sort((a: any, b: any) => {
    const countA = a.unreadTotal || 0;
    const countB = b.unreadTotal || 0; 

    return this.sortByUnReadTotalASC ? countA - countB : countB - countA;
    });
  }
}